__turbopack_context__.v({
  "subtitle": "EventTags-module-scss-module__PkqOaq__subtitle",
  "tagsContainer": "EventTags-module-scss-module__PkqOaq__tagsContainer",
  "title": "EventTags-module-scss-module__PkqOaq__title",
  "titleWithoutSubtitle": "EventTags-module-scss-module__PkqOaq__titleWithoutSubtitle",
  "wrapper": "EventTags-module-scss-module__PkqOaq__wrapper",
});
